import React from "react";
import DeviceTypeListForm from './list/DeviceTypeListForm';
import CreateDeviceTypeForm from './create/CreateDeviceTypeForm'

const DeviceTypeView = ({ displayList }) => {
  return displayList ? (
    <DeviceTypeListForm />
  ) : (
    <CreateDeviceTypeForm />
  );
};

export default DeviceTypeView;
